import React from 'react'

import { ChewyPaymentStepper } from '~/components/dashboard/invoices/payment/payment-details-dialog/chewy-payment/elements/ChewyPaymentsStepper/ChewyPaymentStepper'

import styles from './AddPaymentDialogV2Title.module.scss'

interface AddPaymentDialogV2TitleProps {
  activeStep?: number
  showStepper?: boolean
  title: string
}

const AddPaymentDialogV2Title = ({
  title,
  showStepper = false,
  activeStep = 1,
}: AddPaymentDialogV2TitleProps) => (
  <div className={styles.addPaymentDialogV2TitleContainer}>
    {title}
    {showStepper && (
      <div className={styles.stepperOverride}>
        <ChewyPaymentStepper activeStep={activeStep} />
      </div>
    )}
  </div>
)

export default AddPaymentDialogV2Title
